// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__FoWJI","colCheckbox":"styles_colCheckbox__13OEz"};